export const deriveStateNumber = state => {
    // return state.list.number + 1;
}